var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentFill",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    clipPath: "url(#clip0_238_11315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.8681 8.94701L12.0001 0.747009L1.12212 8.94701C0.897235 9.15453 0.762012 9.44147 0.745117 9.74701V22.269C0.745908 22.5281 0.849202 22.7764 1.03244 22.9597C1.21568 23.1429 1.46398 23.2462 1.72312 23.247H8.24512V18C8.24512 17.0054 8.64021 16.0516 9.34347 15.3484C10.0467 14.6451 11.0006 14.25 11.9951 14.25C12.9897 14.25 13.9435 14.6451 14.6468 15.3484C15.35 16.0516 15.7451 17.0054 15.7451 18V23.25H22.2661C22.5253 23.2492 22.7737 23.146 22.9571 22.9627C23.1405 22.7795 23.2441 22.5312 23.2451 22.272V9.74701C23.2278 9.44158 23.0927 9.15478 22.8681 8.94701Z",
    fill: "currentFill",
    stroke: "#F1F0ED",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_11315"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseIcon);
export default __webpack_public_path__ + "static/media/house_icon.98a7eb3702fdd034acb5605dd7a1a501.svg";
export { ForwardRef as ReactComponent };